// src/features/labTests/labTestsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../../services/api";
import { GET_PHARMACY_DETAILS, UPDATE_PHARMACY_DETAILS } from "../../../services/urls";
import { getPharmacyId } from '../../../utils/commonFunctions';

// Initial state
const initialState = {
  loading: false,
  updateLoading: false,
  pharmacyDetails: [],
  error: null,
};

// Async thunk to fetch pharmacy details
export const fetchPharmacyDetails = createAsyncThunk(
  'pharmacy/loggedInDetails',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_PHARMACY_DETAILS + `/${getPharmacyId()}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch pharmacy details");
    }
  }
);

// Async thunk to update pharmacy details
export const updatePharmacyDetails = createAsyncThunk(
  'pharmacy/updatePharmacyDetails',
  async (pharmacyDetails, { rejectWithValue }) => {
    try {
      const response = await api.put(UPDATE_PHARMACY_DETAILS + `/${getPharmacyId()}`, pharmacyDetails);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update the pharmacy details");
    }
  }
);

// Create slice
const pharmacyDetailsSlice = createSlice({
  name: 'pharmacyDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPharmacyDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPharmacyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.pharmacyDetails = action.payload;
      })
      .addCase(fetchPharmacyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePharmacyDetails.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updatePharmacyDetails.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.error = null;
      })
      .addCase(updatePharmacyDetails.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
      });
  }
});

// Export the reducer (no actions in this case)
export default pharmacyDetailsSlice.reducer;
